import getParagraph from './getParagraph';

const getParagraphRef = (document, location) => {
    const paragraph = getParagraph(document, location);
    return paragraph.reference;
}

export default getParagraphRef;